import React from 'react';
import { PropTypes as PT } from 'prop-types';
import ReactSpinner from 'react16-spinjs';
import classes from './MainSpinner.module.scss';

const MainSpinner = (props) => (
  <div className={`${props.showDelay ? classes.delay : ''}`}>
    <ReactSpinner config={props.config} />
  </div>
);

MainSpinner.propTypes = {
  config: PT.object,
  showDelay: PT.bool
};

MainSpinner.defaultProps = {
  showDelay: false,
  config: {
    lines: 13,
    length: 37,
    width: 19,
    radius: 47,
    color: '#413675',
    speed: 0.7
  }
};

export default MainSpinner;
